import axios from 'axios'
import USER from '../../../assets/icons/USER.svg'
import libphonenumber from 'google-libphonenumber'
import { reactive } from 'vue'

export class User {
  static ABAN_EMAIL = 'aban@aban.com'
  static ME = null
  static phoneNumberUtil = libphonenumber.PhoneNumberUtil.getInstance()

  static getMe(forceGet = false, fetchAuthProgress = false) {
    return new Promise((resolve, reject) => {
      if (User.ME != null || forceGet) {
        if (User.ME.loggedIn === true && !forceGet) {
          resolve(User.ME)
          return
        }
        User.ME.get()
          .then(() => {
            if (fetchAuthProgress) {
              //use it with forceGet=true
              return User.ME.fetchAuthorizationProgress()
            }
          })
          .then(() => {
            resolve(User.ME)
          })
          .catch((error) => {
            reject(error)
          })
        return
      }
      User.ME = User.create({
        loggedIn: false,
        phoneNumber: '+989933426890',
        noLiquidation: true,
        isAdmin: false
      })
      User.ME.get()
        .then(() => {})
        .catch(() => {})
        .finally(() => {
          resolve(User.ME)
        })
    })
  }

  static logout() {
    if (User.ME) {
      User.ME.loggedIn = false
    }
  }

  static getById(id) {
    return new Promise((resolve, reject) => {
      axios
        .get('user/user/' + id)
        .then((response) => {
          resolve(User.create(response.data))
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  static getApiKey() {
    return new Promise((resolve, reject) => {
      axios
        .get('user/api-credential')
        .then((response) => {
          resolve(response.data.apiKey)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  static getAuthenticatorRequirements() {
    return new Promise((resolve, reject) => {
      axios
        .get('user/authenticator/requirements')
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  static create(data, pathFromRoot = null) {
    if (pathFromRoot == null) pathFromRoot = []
    if (data == null) return null
    if (data instanceof User) return data
    for (let obj of pathFromRoot) if (obj instanceof User && obj.id == data.id) return obj
    return reactive(new User(data, pathFromRoot))
  }

  constructor(data, pathFromRoot) {
    this.setUp(data, pathFromRoot)
  }

  setUp(data, pathFromRoot) {
    pathFromRoot.push(this)
    this.address = data.address
    this.email = data.email
    this.emailConfirmed = data.emailConfirmed
    this.fullName = data.fullName
    this.id = data.id
    this.phoneNumber = data.phoneNumber ?? ''
    this.phoneNumberConfirmed = data.phoneNumberConfirmed
    this.internationalFormatPhoneNumber = data.internationalFormatPhoneNumber ?? null
    this.firstName = data.firstName
    this.lastName = data.lastName
    this.fullName = data.fullName
    this.isAdmin = data.isAdmin
    this.roleNames = data.roleNames ?? []
    this.password = 'fuck'
    this.shortDesc = this.fullName + ' (' + this.phoneNumber + ')'
    this.icon = USER
    this.userName = data.userName
    this.loggedIn = data.loggedIn ?? true
    this.createdAt = data.createdAt
    this.noLiquidation = data.noLiquidation
    this.hasPassword = data.hasPassword
    this.fetcherPromise = null
    this.userSegment = data.userSegment
    this.userSegmentLevel = data.userSegmentLevel
    this.hasAuthenticator = data.hasAuthenticator
    this.hasAcceptedRegulations = data.hasAcceptedRegulations
    this.referralCode = data.referralCode
    // this.authorizationStatus = data.authorizationStatus
    try {
      this.countryCode = User.phoneNumberUtil.getRegionCodeForNumber(
        User.phoneNumberUtil.parse(this.phoneNumber, '')
      )
    } catch {
      this.countryCode = 'US'
    }
    pathFromRoot.pop()
  }

  isAban() {
    return this.email == this.ABAN_EMAIL
  }

  get() {
    if (this.fetcherPromise != null) return this.fetcherPromise
    this.fetcherPromise = new Promise((resolve, reject) => {
      axios
        .get('user/user', { cancelOnRouteChange: false })
        .then((response) => {
          this.setUp(response.data, [])
          resolve(this)
        })
        .catch((error) => {
          reject(error)
        })
        .finally(() => {
          this.fetcherPromise = null
        })
    })
    return this.fetcherPromise
  }

  updateNoLiquidation() {
    return new Promise((resolve, reject) => {
      axios
        .put('user/user/' + this.id + '/no-liquidation', { noLiquidation: this.noLiquidation })
        .then((response) => {
          this.setUp(response.data, [])
          resolve(this)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  updateAuthenticatorRequirements(authenticatorRequirements, authenticatorOtp) {
    return new Promise((resolve, reject) => {
      axios
        .put('user/authenticator/requirements', {
          AuthenticatorRequirements: authenticatorRequirements,
          AuthenticatorOtp: authenticatorOtp
        })
        .then((response) => {
          const data = response && response.data
          if (data && (data.id !== undefined || data.hasAuthenticator !== undefined)) {
            this.setUp(data, [])
            resolve(this)
          } else {
            this.get()
              .then(() => resolve(this))
              .catch((err) => reject(err))
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  saveProfile() {
    return new Promise((resolve, reject) => {
      this.saveLoading = true
      axios
        .put(`user/admin/${this.id}/user-profile`, {
          firstName: this.firstName,
          lastName: this.lastName,
          phoneNumber: this.phoneNumber,
          phoneNumberConfirmed: this.phoneNumberConfirmed,
          email: this.email,
          emailConfirmed: this.emailConfirmed,
          noLiquidation: this.noLiquidation,
          userSegment: this.userSegment,
          userSegmentLevel: this.userSegmentLevel
          // authorizationStatus: this.authorizationStatus
        })
        .then((response) => {
          this.setUp(response.data, [])
          resolve(this)
        })
        .catch((error) => {
          reject(error)
        })
        .finally(() => {
          this.saveLoading = false
        })
    })
  }

  static list(page, pageSize, options, axiosConfig = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get('user/users', {
          params: {
            page: page,
            pageSize: pageSize,
            ...options
          },
          ...axiosConfig
        })
        .then((response) => {
          resolve(
            response.data.data
              .map((_user) => User.create(_user))
              .filter((_user) => _user.id !== 1373 || this.ME.id === 4 || this.ME.id === 302)
          )
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  isKycRequired() {
    return (
      this.authorizationStatus != 'AuthorizedLevel1' &&
      this.authorizationStatus != 'Skipped' &&
      this.authorizationStatus != 'AdminVerified' &&
      this.userSegment == 'User' &&
      this.isKycDateEligible()
    )
  }

  isAcknowledgementRequired() {
    return (
      !this.isKycRequired() &&
      this.authorizationStatus != 'NotAuthorized' &&
      this.userSegment == 'User'
    )
  }

  isKycDateEligible() {
    return new Date(this.createdAt) >= new Date('2023-01-01T00:00:00.000000Z')
  }

  fetchAuthorizationProgress() {
    return axios.get('person/authorization-progress').then((response) => {
      if (response?.data?.authorizationStatus !== undefined) {
        this.authorizationStatus = response.data.authorizationStatus
      }
      return response.data
    })
  }

  static getUserRole(userId) {
    return new Promise((resolve, reject) => {
      axios
        .get('/user/admin/user-roles/' + userId)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
  static getRoles() {
    return new Promise((resolve, reject) => {
      axios
        .get('/user/admin/roles')
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
  static updateUserRole(userId, selectedRoles) {
    return new Promise((resolve, reject) => {
      axios
        .put('user/admin/update-user-roles', {
          userId: userId,
          roleIds: selectedRoles
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
  static getUserReferrer(userId) {
    return new Promise((resolve, reject) => {
      axios
        .get('user/admin/get-referrer-user/' + userId)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
  static acceptTerms(version, type) {
    return new Promise((resolve, reject) => {
      axios
        .post('/user/user-confirmation/accept', { version: version, type: type })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
  static getAgreements() {
    return new Promise((resolve, reject) => {
      axios
        .get('user/user-confirmation/get-confirmations')
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  static async hasAcceptedAgreement(type) {
    const agreements = await User.getAgreements()
    const agreementType = type === 'legal' ? 'Regulation' : type

    if (!Array.isArray(agreements)) return false

    return agreements.find((agreement) => agreement.type === agreementType)?.isAccepted === true
  }
}
